import React, { useContext } from 'react';
import { GlobalContext } from '../../context/GlobalState';

export const Balance = () => {
  const { transactions } = useContext(GlobalContext);

  const amounts = transactions.map(transaction => transaction.amount);

  const total = amounts.reduce((acc, item) => (acc += item), 0).toFixed(2);
  const customTotal = total.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");

  return (
    <>
      <h4>Balance</h4>
      <h1 className={total < 0 ? 'money-minus' : 'money-plus'} >${customTotal}</h1>
    </>
  )
}
